import React from "react";
import { Button, DatePicker, Form, Input } from "antd";

/** Event name + start date form. Calls onSubmit({ name, start_date: "YYYY-MM-DD HH:mm:ss" }). */
const EventForm = ({ onSubmit, loading, extra = null }) => {
	const handleFinish = (values) => {
		onSubmit({
			name: values.name.trim(),
			start_date: values.start_date.format("YYYY-MM-DD HH:mm:ss"),
		});
	};
	return (
		<Form layout="vertical" onFinish={handleFinish} requiredMark={false} size="large">
			<Form.Item label="Event name" name="name" rules={[{ required: true, message: "Enter the event name" }]}>
				<Input placeholder="e.g. Spring orientation" />
			</Form.Item>
			<Form.Item label="Start date" name="start_date" rules={[{ required: true, message: "Pick the start date" }]}>
				<DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
			</Form.Item>
			<div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
				<Button type="primary" htmlType="submit" loading={loading}>
					Create event
				</Button>
				{extra}
			</div>
		</Form>
	);
};

export default EventForm;
